/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var LocalStorageService = /** @class */ (function () {
            function LocalStorageService($q) {
                this.$q = $q;
                this.cacheHours = 24;
                this.keys = 'apKeys';
            }
            LocalStorageService.prototype.deleteAllItems = function () {
                var _this = this;
                var storedKeys = this.getApKeys();
                storedKeys.forEach(function (key) {
                    _this.deleteItem(key);
                });
                this.deleteItem(this.keys);
            };
            LocalStorageService.prototype.deleteItem = function (itemKey) {
                localStorage.setItem(itemKey, null);
            };
            LocalStorageService.prototype.getApKeys = function () {
                return JSON.parse(localStorage.getItem(this.keys)) || [];
            };
            LocalStorageService.prototype.getItemWithoutPromise = function (itemKey) {
                var actualItem;
                var item = JSON.parse(localStorage.getItem(itemKey));
                if (ap.Utilities.isNullOrUndefined(item) || new Date(item.expires.toString()).getTime() < new Date().getTime()) {
                    return null;
                }
                return item.actualItem;
            };
            LocalStorageService.prototype.getItem = function (itemKey) {
                return this.$q.when(this.getItemWithoutPromise(itemKey));
            };
            LocalStorageService.prototype.saveApKey = function (itemKey) {
                var storedKeys = this.getApKeys();
                if (storedKeys.indexOf(itemKey) === -1) {
                    storedKeys.push(itemKey);
                    localStorage.setItem(this.keys, JSON.stringify(storedKeys));
                }
            };
            LocalStorageService.prototype.setItem = function (itemKey, item, cacheTimeInMs) {
                var cacheTime = cacheTimeInMs || (this.cacheHours * 60 * 60 * 1000);
                var storageItem = {
                    expires: new Date(new Date().getTime() + cacheTime),
                    actualItem: item
                };
                localStorage.setItem(itemKey, JSON.stringify(storageItem));
                this.saveApKey(itemKey);
            };
            LocalStorageService.$inject = [
                '$q'
            ];
            return LocalStorageService;
        }());
        Services.LocalStorageService = LocalStorageService;
        angular.module('app.Services')
            .service('localStorageService', LocalStorageService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
